<template>
  <NuxtLink
    :href="actualHref"
    :target="props.target"
    :class="cn('text-primary', computedClass)"
  >
    <Icon
      v-if="actualHref?.includes('app.kiriminaja.com')"
      name="material-symbols:bolt-rounded"
      class="inline"
    />
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{
  href?: string
  target?:
    | '_blank'
    | '_parent'
    | '_self'
    | '_top'
    | (string & object)
    | null
    | undefined
}>()

const { $utm } = useNuxtApp()
const { public: config } = useRuntimeConfig()

const actualHref = computed(() => {
  if (!props.href?.length) return undefined

  if (props.href.includes(config.url)) return props.href

  return $utm.utmUrl(props.href || '')
})

const computedClass = computed(() => {
  return actualHref.value?.includes('app.kiriminaja.com')
    ? 'shadow border border-outline-variant no-underline px-1.5 py-0.5 rounded-md hover:shadow-md text-sm'
    : ''
})
</script>
